// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Llama.Customer')
class Llama__Customer {
    @jsonProperty(() => Llama__Customer.Id)
    id: Llama__Customer.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "string" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "name", "isActive", "erpId", "ownerEmail", "projects", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "name", "isActive", "erpId", "ownerEmail", "projects", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "name", "isActive", "erpId", "ownerEmail", "projects", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "name": "string", "isActive": "boolean", "erpId": "string", "ownerEmail": "string", "projects": "Llama.Project[]", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "string" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ projects: () => Llama.Project } as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = String;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θname? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θisActive? = Signals.proxySignalDeferred<boolean>(() => false);
    private readonly θerpId? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θownerEmail? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θprojects? = Signals.proxySignalDeferred<Llama.Project[]>(() => undefined);
    private readonly θcreatedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θupdatedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θdeletedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θversionNumber? = Signals.proxySignalDeferred<number>(() => undefined);

    static get __type(): 'Llama.Customer' {
        return 'Llama.Customer'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Llama.Customer' {
        return 'Llama.Customer'
    }

    static get __baseType(): 'Llama.Customer' {
        return 'Llama.Customer'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Llama.Customer' {
        return 'Llama.Customer'
    }

    get [BoInfoSymbol]() {
        return Llama__Customer[BoInfoSymbol]
    }

    get name(): string {
        return this.θname?.()
    }

    set name(name) {
        this.θname.set(LowgileDataUtil.coerceDataType(name, 'string', false, true))
    }

    get isActive(): boolean {
        return this.θisActive?.()
    }

    set isActive(isActive) {
        this.θisActive.set(LowgileDataUtil.coerceDataType(isActive, 'boolean', false, true))
    }

    get erpId(): string {
        return this.θerpId?.()
    }

    set erpId(erpId) {
        this.θerpId.set(LowgileDataUtil.coerceDataType(erpId, 'string', false, true))
    }

    get ownerEmail(): string {
        return this.θownerEmail?.()
    }

    set ownerEmail(ownerEmail) {
        this.θownerEmail.set(LowgileDataUtil.coerceDataType(ownerEmail, 'string', false, true))
    }

    get projects(): Llama.Project[] {
        return this.θprojects?.()
    }

    set projects(projects) {
        this.θprojects.set(LowgileDataUtil.coerceDataType(projects, Llama.Project, true, true))
        this.projects?.forEach?.(item => { if (item && "customer" in item) item.customer = this as any })
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Llama__Customer>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                projects: [],
                ...init
            }

        }

        LowgileDataUtil.assignCommonProperties(this, init)
        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Llama__Customer()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Llama__Customer>, restrictToClass?: Class<Partial<Llama__Customer>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            name: z.string(),
            isActive: z.boolean(),
            erpId: z.string(),
            ownerEmail: z.string(),
            get projects() { return Llama.Project.$getSchema().array() },
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Llama__Customer.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('name', 'isActive', 'erpId', 'ownerEmail', 'projects', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Llama__Customer {
        return equal(this, other)
    }
}

namespace Llama__Customer { }

export import Customer = Llama__Customer
setTimeout(() => {
    jsonProperty(() => String)(Llama__Customer.prototype, 'name')
    jsonProperty(() => Boolean)(Llama__Customer.prototype, 'isActive')
    jsonProperty(() => String)(Llama__Customer.prototype, 'erpId')
    jsonProperty(() => String)(Llama__Customer.prototype, 'ownerEmail')
    jsonArrayProperty(() => Llama.Project)(Llama__Customer.prototype, 'projects')
    jsonProperty(() => Date)(Llama__Customer.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Llama__Customer.prototype, 'createdBy')
    jsonProperty(() => Date)(Llama__Customer.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Llama__Customer.prototype, 'updatedBy')
    jsonProperty(() => Date)(Llama__Customer.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Llama__Customer.prototype, 'deletedBy')
    jsonProperty(() => Number)(Llama__Customer.prototype, 'versionNumber')
})

export const CustomerθId = String;

export type CustomerθId = string;

namespace Llama__Customer {
    export type Id = NominalType<string, 'Llama.Customer'>

}
